import React from "react"
import PropTypes from "prop-types"
import { Card, Typography, Button } from "antd"
import { CheckCircleFilled, CloseCircleTwoTone } from "@ant-design/icons"
import styles from "./PaymentStatusPage.module.css"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import PowerTranzPaymentResult from "pagesV2/public/PowerTranzPaymentResult"
import { PAYMENT_PROVIDERS } from "constants/powertranz"

const PaymentStatusPage = ({ status }) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  // A PowerTranz checkout's outcome comes from the API, not from which of these URLs it landed on.
  if (searchParams.get("provider") === PAYMENT_PROVIDERS.POWERTRANZ) {
    return <PowerTranzPaymentResult />
  }
  const isSuccess = status === "success"
  return (
    <div className={styles.paymentStatusRoot + (isSuccess ? "" : " " + styles.failure)}>
      <Card className={styles.paymentStatusCard} bordered={false}>
        {isSuccess ? (
          <>
            <div className={styles.successIconWrapper}>
              <span className={styles.successIconCircle}>
                <CheckCircleFilled className={styles.successIcon} />
              </span>
            </div>
            <h2 className={styles.successTitle}>{t("payment.success_title")}</h2>
            <div className={styles.successSubtext}>{t("payment.success_subtext")}</div>
            <div className={styles.buttonGroup}>
              <Button type="primary" size="large" className={styles.primaryBtn} href="/">
                {t("payment.browse_trips")}
              </Button>
            </div>
            {/* Confirmation note removed as requested */}
          </>
        ) : (
          <>
            <div className={styles.iconWrapper}>
              <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 64, animation: "shake 0.7s" }} />
            </div>
            <Typography.Title level={2} className={styles.paymentStatusTitle + " " + styles.failure}>
              {t("payment.failure_title")}
            </Typography.Title>
            <Typography.Text className={styles.paymentStatusMessage}>{t("payment.failure_message")}</Typography.Text>
            {/* Try Again button removed as requested */}
          </>
        )}
      </Card>
    </div>
  )
}

PaymentStatusPage.propTypes = {
  status: PropTypes.oneOf(["success", "failure"]).isRequired
}

export default PaymentStatusPage
